module.exports = __webpack_public_path__ + "static/media/person.226e25fd.png";